import { DualColor } from "../types";

export const primary: DualColor = {
  light: "#00A676", 
  dark: "#00A676"
};
